import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import nlTranslation from './locales/nl/translation.json'
import frTranslation from './locales/fr/translation.json'
import enTranslation from './locales/en/translation.json'
import deTranslation from './locales/de/translation.json'

// Language detection configuration
// Volgt landinstellingen: localStorage (eerdere keuze) → navigator (OS/browser) → htmlTag (fallback uit index.html)
// Engelstalige reviewers / klanten op een EN-Windows krijgen automatisch EN UI.
// Pas wanneer de gebruiker expliciet via de LanguageSwitcher kiest, wint die keuze (localStorage + DB).
const detectionOptions = {
  // navigator (OS/browser) WINT vóór htmlTag — anders blokkeert <html lang="..."> alles
  order: ['localStorage', 'navigator', 'htmlTag'],

  // Keys to lookup language from
  lookupLocalStorage: 'i18nextLng',

  // Cache user language
  caches: ['localStorage'],

  // Exclude path from detection
  excludeCacheFor: ['cimode'],

  checkWhitelist: false
}

// Guard against double initialization
if (!i18n.isInitialized) {
  i18n
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
    // Load user language preference from API on startup (if logged in)
    // This will be handled by a useEffect hook in App.jsx or Layout.jsx
    // Fallback language — EN als universele fallback voor niet-supported talen
    // (Spaans, Italiaans, etc. → 'en' i.p.v. 'nl'). NL blijft beschikbaar als
    // expliciete keuze via LanguageSwitcher of nl-BE/nl-NL browser-detectie.
    fallbackLng: 'en',

    // Supported languages
    supportedLngs: ['nl', 'fr', 'en', 'de'],

    // Negeer regio-suffix: nl-BE → nl, en-US → en, fr-CH → fr, de-AT → de
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    
    // Default namespace
    defaultNS: 'translation',
    
    // Namespaces
    ns: ['translation'],
    
    // Resources
    resources: {
      nl: {
        translation: nlTranslation
      },
      fr: {
        translation: frTranslation
      },
      en: {
        translation: enTranslation
      },
      de: {
        translation: deTranslation
      }
    },
    
    // Detection options
    detection: detectionOptions,
    
    // React options
    react: {
      useSuspense: false, // Disable suspense for better compatibility
      bindI18n: 'languageChanged loaded', // Bind to language changes
      bindI18nStore: 'added removed' // Bind to store changes
    },
    
    // Interpolation options
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    // Enable returnObjects for nested translation objects/arrays
    returnObjects: true,
    
    // Debug mode: off to avoid "missingKey" console spam (key may exist but translator logs before resolve)
    debug: false,

    // Suppress missingKey console output for known-safe keys (translator logs before handler)
    logger: typeof window !== 'undefined' ? {
      log: (...args) => {
        const str = args.map(a => (a != null ? String(a) : '')).join(' ')
        if (str.includes('missingKey') && str.includes('layout.navigation.team')) return
        console.log(...args)
      },
      warn: (...args) => {
        const str = args.map(a => (a != null ? String(a) : '')).join(' ')
        if (str.includes('missingKey') && str.includes('layout.navigation.team')) return
        console.warn(...args)
      },
      error: (...args) => { console.error(...args) }
    } : undefined,

    // Don't log missingKey for keys that have a safe default (e.g. layout.navigation.team)
    missingKeyHandler: (lngs, ns, key, defaultValue) => {
      if (key === 'layout.navigation.team') return
      if (typeof window !== 'undefined' && window.i18nMissingKeyHandler) {
        window.i18nMissingKeyHandler(lngs, ns, key, defaultValue)
      } else if (process.env.NODE_ENV === 'development') {
        console.warn(`i18next: missingKey ${lngs} ${ns} ${key}`, defaultValue)
      }
    }
  })
}

export default i18n
